import { render, staticRenderFns } from "./DictionaryItemModal.vue?vue&type=template&id=4dad85bc&"
import script from "./DictionaryItemModal.vue?vue&type=script&lang=js&"
export * from "./DictionaryItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports